import { Typography } from '@mui/material';
import { TagChip } from 'components/ui';
import colors from 'lib/colors';
import { TableContext } from 'pages/PatientsPage';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export const PatientGroupFilterChip = () => {
  const { t } = useTranslation();
  const { filters, setFilters } = useContext(TableContext);

  function handleDelete(patientGroup) {
    const newPatientGroupFilter = filters?.patientGroupIds?.filter(
      (item) => item.id !== patientGroup.id
    );
    setFilters({
      ...filters,
      patientGroupIds: newPatientGroupFilter,
    });
  }

  return filters?.patientGroupIds?.map((patientGroup) => (
    <TagChip
      key={patientGroup.id}
      tag={
        <>
          <Typography
            component="span"
            color={colors.black}
            fontSize={'0.875rem'}
            fontWeight={'500'}
            textTransform={'capitalize'}
          >
            {`${t('Patient group')}: `}
          </Typography>
          <Typography
            component="span"
            color={colors.blue100}
            fontSize={'0.875rem'}
            fontWeight={'500'}
          >
            {patientGroup.title}
          </Typography>
        </>
      }
      handleDelete={() => handleDelete(patientGroup)}
      isCanDelete
      iconColor={colors.blue100}
    />
  ));
};
